export enum ViewActionType {
  TOGGLE_FLYOUT = "TOGGLE_FLYOUT",
  CLOSE_FLYOUT = "CLOSE_FLYOUT",
  SYNC_NESTED_NODES_WITH_MOBILE = "SYNC_NESTED_NODES_WITH_MOBILE"
}
